export const doel = {
  title: 'Referentiekader Taal (Meijerink)',
  color: 'white',
  children: {
    'Spreken': {
      children: {
        'Gesprekken': {
          description: 'Kan in gesprekken over alledaagse en niet-alledaagse onderwerpen uit dagelijks leven, werk en opleiding uiting geven aan persoonlijke meningen, kan informatie uitwisselen en gevoelens onder woorden brengen.',
          children: {  
            'Discussie en Overleg': {
              description: 'Deelnemen aan discussie en overleg',
              isLeaf: true,
              children: {            
                'spreken.g.d.plannen': {
                  title: 'Plannen',
                  code: 'm1',
                  description: 'Kan bespreken wat er gedaan moet worden en bijdragen aan de planning'
                },
                'spreken.g.d.discussieren': {
                  title: 'Afstemmen op doel',
                  code: 'm2',
                  description: 'Kan tijdens een discussie of overleg (op beleefde wijze) een probleem verhelderen, een overtuiging of mening, instemming of afkeuring uitdrukken en commentaar geven op de visie van anderen'
                }
              }
            },
            'Informatie uitwisselen': {
              isLeaf: true,
              children: {
                'spreken.g.i.uitwisselen': {
                  title: 'Informatie uitwisselen',
                  code: 'm3',
                  description: 'Kan informatie vragen en geven aan instanties binnen en buiten school.'
                },
                'spreken.g.i.verwerken': {
                  title: 'Informatie verzamelen',
                  code: 'm4',
                  description: 'Kan informatie verzamelen en verwerken via het houden van een vraaggesprek'
                }
              }
            },                      
            'spreken.g.bijdragen': {
              title: 'Bijdragen aan samenhang',
              isLeaf: true,
              children: {
                'spreken.g.bijdragen.woord': {
                  title: 'Kan de juiste frase gebruiken om aan het woord te komen.',
                  code: 'm5'
                },
                'spreken.g.bijdragen.reactie': {
                  title: 'Kan een reactie uitstellen totdat hij de bijdrage van de ander geïnterpreteerd en beoordeeld heeft.',
                  code: 'm6'
                }
              }
            },
            'spreken.g.doel': {
              title: 'Afstemmen op doel',
              isLeaf: true,
              children: {
                'spreken.g.doel.eigen': {
                  title: 'Kan het eigen gespreksdoel tot uitdrukking brengen',
                  code: 'm7'
                },
                'spreken.g.doel.vragen': {
                  title: 'Kan doelgericht doorvragen om de gewenste informatie te verwerven.',
                  code: 'm8'
                }
              }
            },
            'spreken.g.partners': {
              title: 'Afstemmen op partners',
              isLeaf: true,
              children: {
                'spreken.g.partners.herkennen': {
                  title: 'Kan het spreekdoel van anderen herkennen en reacties inschatten.',
                  code: 'm9'
                },
                'spreken.g.partners.formeel': {
                  title: 'Kan het verschil tussen formele en informele situaties hanteren.',
                  code: 'm10'
                },
                'spreken.g.partners.variatie': {
                  title: 'Maakt de juiste keuze voor het register en het al dan niet hanteren van taalvariatie (dialect, jongerentaal).',
                  code: 'm11'
                }

              }
            },
            'spreken.g.w': {
              title: 'Woordenschat',
              description: 'Beschikt over voldoende woorden om zich te kunnen uiten. Het kan soms nog nodig zijn een omschrijving te geven van een onbekend woord.',
              code: 'm12'
            },
            'spreken.g.grammatica': {
              title: 'Grammatica',
              code: 'm13',
              description: 'De uitspraak is duidelijk verstaanbaar, ondanks een eventueel accent, af en toe een verkeerd uitgesproken woord en/of haperingen. Vertoont een redelijke grammaticale beheersing. Aarzelingen en fouten in zinsbouw zijn eigen aan gesproken taal en komen dus voor, maar worden zo nodig hersteld.'
            }
          }
        },
        'Luisteren': {
          description: 'Kan luisteren naar teksten over alledaagse onderwerpen, onderwerpen die aansluiten bij de leefwereld van de leerling of die verder van de leerling afstaan.',
          children: {
            'spreken.l.instr': {
              title: 'Instructies',
              code: 'm14',
              description: 'Kan uitleg en instructies over dagelijkse werkzaamheden begrijpen.'
            },
            'Live': {
              description: 'Luisteren als lid van een live publiek',
              isLeaf: true,
              children: {
                'spreken.l.l.toedracht': {
                  code: 'm15',
                  title: 'Kan een helder gestructureerde voordracht, toespraak of, les begrijpen over vertrouwde onderwerpen binnen het eigen vak- of interessegebied'
                },
                'spreken.l.l.verhaal': {
                  code: 'm16',
                  title: 'Kan een voorgelezen of verteld verhaal begrijpen'
                }
              }
            },
            'spreken.l.rtv': {
              isLeaf: true,
              title: 'RTV / Internet',
              description: 'Luisteren naar radio en televisie en naar gesproken tekst op internet',
              children: {
                'spreken.l.rtv.hoofd': {
                  code: 'm17',
                  title: 'Kan de hoofdpunten begrijpen van (nieuws)berichten, documentaires, reclameboodschappen en discussieprogramma’s over vertrouwde onderwerpen.'
                },
                'spreken.l.rtv.volgen': {
                  code: 'm18',
                  title: 'Kan films en tv-series, geschikt voor de leeftijd, volgen.'
                }
              }
            },            
            'spreken.l.b': {
              title: 'Begrijpen',
              isLeaf: true,
              children: {
                'spreken.l.b.hoofd': {
                  code: 'm19',
                  title: 'Kan de hoofdgedachte van de tekst weergeven'
                },
                'spreken.l.b.onderscheid': {
                  code: 'm20',
                  title: 'Kan onderscheid tussen hoofd- en bijzaken maken'
                },
                'spreken.l.b.details': {
                  code: 'm21',
                  title: 'Kan noodzakelijke details begrijpen'
                },
                'spreken.l.b.relaties': {
                  code: 'm22',
                  title: 'Kan relaties tussen tekstdelen leggen'
                },
                'spreken.l.b.ordenen': {
                  code: 'm23',
                  title: 'Kan informatie ordenen (bijvoorbeeld op basis van signaalwoorden) voor een beter begrip'
                },
                'spreken.l.b.betekenis': {
                  code: 'm24',
                  title: 'Kan wanneer nodig de betekenis van onbekende woorden afleiden uit de vorm, woordsoort, samenstelling of context.'
                },
                'spreken.l.b.ironie': {
                  code: 'm25',
                  title: 'Kan beeldspraak en ironie herkennen.'
                },
                'spreken.l.b.beeld': {
                  code: 'm26',
                  title: 'Kan een relatie leggen tussen tekst en beeld'
                }
              }
            },
            'spreken.l.i': {
              title: 'Interpreteren',
              isLeaf: true,
              children: {
                'spreken.l.i.i': {
                  code: 'm27',
                  title: 'Kan informatie en meningen interpreteren'
                },
                'spreken.l.i.verwoorden': {
                  code: 'm28',
                  title: 'Kan de bedoeling van de spreker(s) of het doel van de makers van een programma verwoorden.'
                }
              }
             
            },
            'spreken.l.e': {
              title: 'Evalueren',
              code: 'm29',
              description: 'Kan een oordeel over de waarde van een tekst(deel) of tv- of radioprogramma (of fragment ervan) verwoorden voor zichzelf en kan dit oordeel toelichten'
            },
            'spreken.l.s': {
              title: 'Samenvatten',
              code: 'm30',
              description: 'Kan een eenvoudige tekst beknopt samenvatten (voor zichzelf)'
            }
          }
        },
        'Spreken': {
          description: 'Kan redelijk vloeiend en helder ervaringen, gebeurtenissen, meningen, verwachtingen en gevoelens onder woorden brengen over onderwerpen uit de (beroeps)opleiding en van maatschappelijke aard.',
          children: {
            'Monoloog': {
              isLeaf: true,
              children: {
                'spreken.s.mono.redenen': {
                  code: 'm31',
                  title: 'Kan in grote lijnen redenen en verklaringen geven voor eigen meningen, plannen en handelingen en kan een kort verhaal vertellen.'
                },
                'spreken.s.mono.verzamelen': {
                  code: 'm32',
                  title: 'Kan informatie verzamelen om over een onderwerp uit zijn interessegebied een voorbereide presentatie te geven.'
                },
                'spreken.s.mono.vragen': {
                  code: 'm33',
                  title: 'Kan vragen beantwoorden naar aanleiding van deze presentatie.'
                }
              }
            },
            'spreken.s.samenhang': {
              title: 'Samenhang',
              code: 'm34',
              description: 'Kan een duidelijk verhaal houden met een samenhangende opsomming van punten en kan daarbij duidelijk maken welk punt hij het belangrijkst vindt. Gebruikt korte eenvoudige zinnen en verbindt deze door de juiste, eenvoudige voegwoorden en verbindingswoorden'
            },
            'spreken.s.doel': {
              title: 'Afstemmen op doel',
              code: 'm35',
              description: 'Geeft spreekdoel duidelijk vorm (instruerend, informatief, onderhoudend, enz.), zodat het voor de luisteraar herkenbaar is'
            },
            'spreken.s.publiek': {
              title: 'Afstemmen op publiek',
              isLeaf: true,
              children: {
                'spreken.s.p.formeel': {
                  code: 'm36',
                  title: 'Kan het verschil tussen formele en informele situaties hanteren.'
                },
                'spreken.s.p.variatie': {
                  code: 'm37',
                  title: 'Maakt de juiste keuze voor het register en het al dan niet hanteren van taalvariatie (dialect, jongerentaal).'
                },
                'spreken.s.p.boeien': {
                  code: 'm38',
                  title: 'Kan de luisteraar(s) boeien door middel van concrete voorbeelden en ervaringen.'
                }
              }
            }
          }
        }
      }
    },
    'Lezen': {
      children: {
        'Zakelijk': {
          description: 'Kan teksten lezen over alledaagse onderwerpen, onderwerpen die aansluiten bij de leefwereld van de lezer en over onderwerpen die verder van de lezer afstaan.',
          children: {
            'lezen.z.inf': {
              title: 'Informatieve teksten',
              code: 'm39',
              description: 'Kan informatieve teksten lezen, waaronder \n- schoolboek en studieteksten (voor taal- en zaakvakken),\n- standaardformulieren,\n- populaire tijdschriften,\n- teksten van internet,\n- notities en schematische informatie (waarin verschillende dimensies gecombineerd worden),\n- het alledaagse nieuws in de krant.'
            },
            'lezen.z.instr': {
              title: 'Instructies',
              code: 'm40',
              description: 'Kan instructieve teksten lezen, zoals\n- recepten,\n- veelvoorkomende aanwijzingen,\n- gebruiksaanwijzingen,\n- bijsluiters van medicijnen.'
            },
            'lezen.z.betoog': {
              title: 'Betoog',
              code: 'm41',
              description: 'Kan betogende, vaak redundante teksten lezen, zoals\n- reclameteksten,\n- advertenties,\n- folders,\n- brochures van formele instanties,\n- licht opiniërende artikelen uit tijdschriften.'
            },
            'lezen.z.woordenschat': 'Woordenschat',
            'lezen.z.b': {
              title: 'Begrijpen',
              isLeaf: true,
              children: {
                'lezen.z.b.hoofd': {
                  code: 'm42',
                  title: 'Kan de hoofdgedachte van de tekst weergeven en maakt onderscheid tussen hoofd- en bijzaken'
                },
                'lezen.z.b.relaties': {
                  code: 'm43',
                  title: 'Legt relaties tussen tekstdelen (inleiding, kern, slot) en teksten'
                },
                'lezen.z.b.ordenen': {
                  code: 'm44',
                  title: 'Ordent informatie (bijvoorbeeld op basis van signaalwoorden) voor een beter begrip'
                },
                'lezen.z.b.beeldspraak': {
                  code: 'm45',
                  title: 'Herkent beeldspraak (letterlijk en figuurlijk taalgebruik)'
                }
              }
            },
            'lezen.z.i': {
              title: 'Interpreteren',
              isLeaf: true,
              children: {
                'lezen.z.i.relaties': {
                  code: 'm46',
                  title: 'Legt relaties tussen tekstuele informatie en meer algemene kennis'
                },
                'lezen.z.i.bedoeling': {
                  code: 'm47',
                  title: 'Kan de bedoeling van tekstgedeeltes en/of specifieke formuleringen duiden'
                },
                'lezen.z.i.schrijver': {
                  title: 'Kan de bedoeling van de schrijver verwoorden.',
                  code: 'm48'
                }
              }
            },
            'lezen.z.e': {
              title: 'Evalueren',
              code: 'm49',
              description: 'Kan relaties tussen en binnen teksten evalueren en beoordelen'
            },
            'lezen.z.s': {
              title: 'Samenvatten',
              code: 'm50',
              description: 'Kan een eenvoudige tekst beknopt samenvatten'
            },
            'lezen.z.opzoeken': {
              title: 'Opzoeken',
              code: 'm51',
              description: 'Kan systematisch informatie zoeken (op bijvoorbeeld het internet of de schoolbibliotheek) bijvoorbeeld op basis van trefwoorden.'
            }
          }
        },
        'Fictie': {
          description: 'Kan eenvoudige adolescentenliteratuur herkennend lezen.',
          children: {
            'lezen.f.begrijpen': {
              title: 'Begrijpen',
              isLeaf: true,
              children: {
                'lezen.f.b.genre': {
                  code: 'm52',
                  title: 'Herkent het genre'
                },
                'lezen.f.b.letterlijk': {
                  code: 'm53',
                  title: 'Herkent letterlijk en figuurlijk taalgebruik'
                },
                'lezen.f.b.situaties': {
                  code: 'm54',
                  title: 'Kan situaties en verwikkelingen in de tekst beschrijven'
                },
                'lezen.f.b.denken': {
                  code: 'm55',
                  title: 'Kan het denken, voelen en handelen van personages beschrijven'
                },
                'lezen.f.b.ontwikkeling': {
                  code: 'm56',
                  title: 'Kan de ontwikkeling van de hoofdpersoon beschrijven'
                },
                'lezen.f.b.geschiedenis': {
                  code: 'm57',
                  title: 'Kan de geschiedenis chronologisch navertellen'
                }
              }
            },
            'Interpreteren': {
              isLeaf: true,
              children: {
                'lezen.f.i.realistisch': {
                  code: 'm58',
                  title: 'Kan bepalen in welke mate de personages en gebeurtenissen herkenbaar en realistisch zijn.'
                },
                'lezen.f.i.personages': {
                  code: 'm59',
                  title: 'Kan personages typeren, zowel innerlijk als uiterlijk.'
                },
                'lezen.f.i.onderwerp': {
                  code: 'm60',
                  title: 'Kan het onderwerp van de tekst benoemen.'
                }
              }
            },
            'Evalueren': {
              isLeaf: true,
              children: {
                'lezen.f.e.argumenten': {
                  code: 'm61',
                  title: 'Evalueert de tekst ook met realistische argumenten en kan persoonlijke reacties toelichten met voorbeelden uit de tekst.'
                },
                'lezen.f.e.ervaringen': {
                  code: 'm62',
                  title: 'Kan met medeleerlingen leeservaringen uitwisselen en kan de interesse in bepaalde genres of onderwerpen motiveren.'
                }
              }
            }
          }
        }
      }
    },
    'Schrijven': {
      description: 'Kan samenhangende teksten schrijven met een eenvoudige, lineaire opbouw, over uiteenlopende vertrouwde onderwerpen uit de (beroeps)opleiding en van maatschappelijke aard.',
      children: {
        'Correspondentie': {
          children: {
            'schrijven.c.informeel': {
              title: 'Informele brief',
              code: 'm63',
              description: 'Kan e-mails of informele brieven schrijven en daarbij meningen en gevoelens uitdrukken.'
            },
            'schrijven.c.zakelijk': {
              title: 'Zakelijke brief',
              code: 'm64',
              description: 'Kan met behulp van standaardformuleringen eenvoudige zakelijke brieven produceren en schriftelijke verzoeken opstellen.'
            },
          }
        },
        'Formulieren': {
          description: 'Formulieren invullen, berichten, advertenties en aantekeningen',
          children: {
            's.form.notities': {
              title: 'Notities',
              code: 'm65',
              description: 'Kan\n- notities,\n- berichten\n- instructies\nschrijven waarin eenvoudige informatie van onmiddellijke relevantie voor vrienden, docenten en anderen wordt overgebracht.'
            },
            's.form.invullen': {
              title: 'Formulier',
              code: 'm66',
              description: 'Kan formulieren invullen'
            },
            's.form.advertentie': {
              title: 'Advertentie',
              code: 'm67',
              description: 'Kan een advertentie opstellen om bijvoorbeeld spullen te verkopen.'
            },
            's.form.aantekeningen': {
              title: 'Aantekeningen',
              code: 'm68',
              description: 'Kan aantekeningen maken tijdens een uitleg of, les.'
            }
          }
        },
        'Verslagen': {
          children: {
            's.verslagen.maken': {
              title: 'Verslagen maken',
              code: 'm69',
              description: 'Kan artikelen, verslagen en werkstukken schrijven met behulp van een stramien en daarbij informatie uit verscheidene bronnen samenvoegen.'
            },
            's.verslagen.samenvattingen': {
              title: 'Samenvattingen',
              code: 'm70',
              description: 'Kan samenvattingen schrijven'
            },
            's.verslagen.overtuigen': {
              title: 'Overtuigen',
              code: 'm71',
              description: 'Kan onderhoudende teksten schrijven en overtuigen met argumenten.'
            },
            's.verslagen.media': {
              title: 'Media',
              code: 'm72',
              description: 'Kan een collage, een krant of muurkrant maken. [animatie, film]'
            }
          }
        },
        's.schrijven': {
          title: 'Schrijven',
          children: {
            's.vrij': {
              title: 'Vrij',
              description: 'Vrij schrijven',
              code: 'm73',
              description: 'Kan eigen ideeën, ervaringen, gebeurtenissen en fantasieën opschrijven in een verhaal, in een informatieve tekst of in een gedicht.'
            },            
            'schrijven.s': {
              title: 'Samenhang',
              isLeaf: true,
              children: {
                'schrijven.s.verbinding': {
                  code: 'm74',
                  title: 'Gebruikt veelvoorkomende verbindingswoorden (als, hoewel) correct'
                },
                'schrijven.s.volgorde': {
                  code: 'm75',
                  title: 'De tekst bevat een volgorde; inleiding, kern en slot'
                },
                'schrijven.s.verbanden': {
                  code: 'm76',
                  title: 'Kan alinea’s maken en inhoudelijke verbanden expliciet aangeven. Maakt soms nog onduidelijke verwijzingen en fouten in de structuur van de tekst'
                }
              }
            },
            'schrijven.s.doel': {
              title: 'Afstemmen op doel',
              code: 'm77',
              description: 'Kan in teksten met een eenvoudige lineaire structuur trouw blijven aan het doel van het schrijfproduct'
            },
            'schrijven.s.publiek': {
              title: 'Afstemmen op publiek',
              code: 'm78',
              description: 'Past het woordgebruik en toon aan het publiek aan'
            },
            'Woordgebruik': {
              code: 'm79',
              description: 'Varieert het woordgebruik, fouten met idiomatische uitdrukkingen komen nog voor'
            },
            'schrijven.s.grammatica': {
              title: 'Spelling en Grammatica',
              description: 'Spelling, interpunctie en grammatica; vertoont een redelijke grammaticale beheersing'
            },
            'schrijven.s.titel': {
              title: 'Gebruikt titel en tekstkopjes.',
              code: 'm80'
            },
            'schrijven.s.leesbaarheid': {
              title: 'Leesbaarheid',
              code: 'm81',
              description: 'Kan bij korte teksten lay-out aanbrengen. Heeft bij langere teksten (meer dan twee A4) ondersteuning nodig bij aanbrengen van de lay-out'
            }
          }
        }
        
      }
    },
    'Taalverzorging': {
      children: {
        'Spelling': {
          children: {
            'Woorden': {
              description: 'Moeilijke gevallen',
              isLeaf: true,
              children: {
                'taal.s.w.meervoud': {
                  title: 'Meervoud -s na klinker',
                  description: '(meisjes, garages, fuchsia’s, cafés)',
                  code: 'm82'
                },
                'taal.s.w.verkleinwoord': {
                  title: 'Verkleinwoord na open klinker',
                  description: '(parapluutje)',
                  code: 'm83'
                },
                'taal.s.w.s': {
                  title: '’s in ’s ochtends',
                  code: 'm84'
                },
                'taal.s.w.stoffelijk': {
                  title: 'Stoffelijke bijvoeglijke naamwoorden op -en',
                  code: 'm85'
                },
                'taal.s.w.verwijzing': {
                  title: 'Meervouds -n bij zelfstandig gebruikte verwijzing',
                  description: '(allen versus alle)',
                  code: 'm86'
                },
                'taal.s.w.samengesteld': {
                  title: 'Wel of niet -n in samengestelde woorden',
                  code: 'm87'
                }
              }
            
            },
            'taal.s.ww': {
              title: 'Werkwoordspelling',
              isLeaf: true,
              children: {
                'taal.s.ww.homofoon': {
                  code: 'm88',
                  title: 'Moeilijke gevallen: persoonsvorm. Homofone gevallen: tegenwoordige tijd stam op -d enkelvoud (hij wordt/word)'
                },
                'taal.s.ww.tegenwoordig': {
                  code: 'm89',
                  title: 'Tegenwoordige tijd (klankvaste of zwakke) werkwoorden, enkelvoud'
                },
                'taal.s.ww.verleden': {
                  code: 'm90',
                  title: 'Verleden tijd (klankvaste of zwakke) werkwoorden met stam op -d of -t'
                }
              }
            },
            'taal.s.regels': {
              title: 'Regels',
              code: 'm91',
              description: 'Spelambigue woorden'
            },
            'Begrippen': {
              code: 'm92',
              description: 'Werkwoord, tijd van het werkwoord, getal, persoon, persoonsvorm, voltooid deelwoord, stam, hele werkwoord, onderwerp, zwakke/sterke werkwoorden, werkwoordelijk gezegde, ‘kofschip’.'
            },
            'Hoofdletters': {
              code: 'm93',
              description: 'Hoofdletters bij eigennaam en directe rede'
            }
          }
        },
        'Begrippen': {
          children: {
            'Leestekens': {
              description: 'Trema, accent, dubbele punt, punt, komma, puntkomma, uitroepteken, vraagteken, aanhalingsteken',
              code: 'm94'
            },
            'taal.b.soorten': {
              title: 'Woordsoorten',
              code: 'm95',
              description: 'Zelfstandig naamwoord, werkwoord (klankvast, klankveranderend (zwak, sterk)), bijvoeglijk naamwoord.'
            },
            'Grammaticale kennis': {
              code: 'm96',
              description: 'Lijdende en bedrijvende vorm, vragende vorm. Onderwerp, lijdend voorwerp, hoofdzin, bijzin, gezegde, persoonsvorm.'
            },
            'taal.b.kennis': {
              title: 'Tekstkennis',
              code: 'm97',
              description: 'Aanduidingen voor tekstsoorten en genres (ook: aanduidingen voor gespreksvormen), hoofdgedachte (van tekst), tekstthema. Metatalige vormen: woorden, zinnen en tekstfragmenten die informatie geven over de rest van de tekst (zoals signaalwoorden, prospectieve en retrospectieve tekstelementen in inleiding, samenvattende zin aan slot)'
            },
            'Stilistiek': {
              description: 'Homoniem, homofoon, vakjargon, stilistische adequaatheid (publiekgericht), presentatiekenmerken (van mondelinge en schriftelijke tekst).',
              code: 'm98'
            },
            'Morfologie': {
              code: 'm99',
              description: 'Woordvorm, woorddeel, samengesteld, voorvoegsel, achtervoegsel, lettergreep. Getal (meervoud/enkelvoud), tijd (tegenwoordig, verleden, voltooid, onvoltooid). Verkleinwoord, verschijningsvormen werkwoord (stam, infinitief, bijvoeglijk naamwoord).'
            },
            'Klanken': {}
          }
        }
      }
    }
  }
}
